/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordRequest as ModelsContactChangePasswordRequest } from '../../models/Models/Contact/change-password-request';

export interface V4ContactsMePasswordPut$Json$Params {
      body?: ModelsContactChangePasswordRequest
}

export function v4ContactsMePasswordPut$Json(http: HttpClient, rootUrl: string, params?: V4ContactsMePasswordPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v4ContactsMePasswordPut$Json.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v4ContactsMePasswordPut$Json.PATH = '/v4/contacts/me/password';
